import React from 'react';
import { useI18n } from '../../services/i18n';

export default function Onboarding({ onFinish }) {
  const { t } = useI18n();

  const openGuide = (e) => {
    e.preventDefault();
    const url = 'https://teletype.in/@webcamtraffic/stripchat-traffic-bot';
    if (window.Telegram?.WebApp?.openLink) {
      window.Telegram.WebApp.openLink(url);
    } else {
      window.open(url, '_blank');
    }
  };

  const handleStart = (targetScreen) => {
    localStorage.setItem('onboarded', '1');
    onFinish(targetScreen);
  };

  return (
    <main className="screen screen--plain" data-testid="screen-onboarding">
      <div className="col" style={{ gap: '14px' }}>
        <h1 style={{ fontSize: '28px', lineHeight: 1.15 }}>
          {t('onboard_title')}
        </h1>
        <p className="muted" style={{ margin: 0, fontSize: '15px', lineHeight: 1.5 }}>
          {t('onboard_sub')}
        </p>
      </div>

      <ol className="steps">
        <li>
          <span className="steps__n">1</span>
          <div className="col" style={{ gap: '4px' }}>
            <b>{t('onboard_step1_title')}</b>
            <span className="muted" style={{ fontSize: '14px', lineHeight: 1.45 }}>
              {t('onboard_step1_desc')}
            </span>
          </div>
        </li>
        <li>
          <span className="steps__n">2</span>
          <div className="col" style={{ gap: '4px' }}>
            <b>{t('onboard_step2_title')}</b>
            <span className="muted" style={{ fontSize: '14px', lineHeight: 1.45 }}>
              {t('onboard_step2_desc')}
            </span>
          </div>
        </li>
        <li>
          <span className="steps__n">3</span>
          <div className="col" style={{ gap: '4px' }}>
            <b>{t('onboard_step3_title')}</b>
            <span className="muted" style={{ fontSize: '14px', lineHeight: 1.45 }}>
              {t('onboard_step3_desc')}
            </span>
          </div>
        </li>
      </ol>

      <a
        className="list__row"
        style={{
          border: '1px solid var(--line)',
          borderRadius: '14px',
          padding: '14px 16px',
          color: 'var(--text-2)',
          textDecoration: 'none',
        }}
        href="https://teletype.in/@webcamtraffic/stripchat-traffic-bot"
        onClick={openGuide}
      >
        {t('onboard_guide_link')} <span>↗</span>
      </a>

      <div style={{ flex: 1 }} />

      <div className="col">
        <button
          className="btn btn--primary"
          onClick={() => handleStart('order')}
          data-testid="onboard-order"
        >
          {t('onboard_btn_order')}
        </button>
        <button
          className="btn btn--secondary"
          onClick={() => handleStart('wallet')}
          data-testid="onboard-wallet"
        >
          {t('onboard_btn_wallet')}
        </button>
      </div>
    </main>
  );
}
